import { productIdFormat } from "@redotech/redo-ids-cockroach";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const SkuForecastInput_ = z.object({
  productId: productIdFormat.schema,
  sku: z.string(),
  historicalSales: z.array(z.number()),
  historicalDates: z.array(zExt.plainDate()),
  historicalPrices: z.array(z.number()),
  futurePrices: z.array(z.number()),
});

export const SkuForecastInput: z.ZodType<SkuForecastInput> = SkuForecastInput_;
export interface SkuForecastInput extends z.infer<typeof SkuForecastInput_> {}

const SkuForecastResult_ = z.object({
  sku: z.string(),
  dates: z.array(zExt.plainDate()),
  predictions: z.array(z.number()),
  lowerBounds: z.array(z.number()),
  upperBounds: z.array(z.number()),
  regimeChangeDetected: z.boolean(),
  regimeChangeIndex: z.number().int().nullable(),
});

export const SkuForecastResult: z.ZodType<SkuForecastResult> =
  SkuForecastResult_;
export interface SkuForecastResult extends z.infer<typeof SkuForecastResult_> {}

export const runScenarioForecast = {
  name: "runScenarioForecast" as const,
  input: z.object({
    skus: z.array(SkuForecastInput),
    firstPredictDate: zExt.plainDate(),
    forecastHorizon: z.number().int().default(384),
  }),
  output: z.object({
    forecasts: z.array(SkuForecastResult),
    inferenceTimeMs: z.number(),
  }),
};
